// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.payment.CreateOneTimePaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CreateOneTimePaymentWebApiRequestDto, CreateOneTimePaymentWebApiResponseDto } from '../..';

export const CreateOneTimePaymentWebApiHandler_createOneTimePayment_Path = '/api/web/v1/payment/createOneTimePayment';

/**
 * Create a one-time payment request
 */
export const CreateOneTimePaymentWebApiHandler_createOneTimePayment = (
  postData: CreateOneTimePaymentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateOneTimePaymentWebApiRequestDto, CreateOneTimePaymentWebApiResponseDto>(
    {
      endpoint: CreateOneTimePaymentWebApiHandler_createOneTimePayment_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
